<template>
  <div>
    <div class="control">
      <label for="police-report-filed-date" class="text-question">
        <slot name="tooltip1" />
      </label>
      <Field
        id="police-report-filed-date"
        v-slot="{ field }"
        :rules="{ required: true }"
        :label="contentModel.ErrorMessagePoliceReportWhen"
        name="police-report-filed-date"
      >
        <date-picker
          v-bind="field"
          id="police-report-filed-date"
          :name="field.name"
          :min-date="claimEventDate"
          :max-date="maxDate"
          :date="policeReportFiledDate"
          :data-test-claim-event-date="claimEventDate"
          :data-test-selected-police-report-filed-date="policeReportFiledDate"
          class="datepicker"
          @date-changed="updateDate"
        />
        <ValidationError :name="field.name" />
      </Field>
    </div>

    <div class="control">
      <label for="police-report-number" class="text-question">
        <slot name="tooltip2" />
      </label>
      <Field
        id="police-report-number"
        :value="modelValue.PoliceReportNumber"
        :rules="'required'"
        type="text"
        name="police-report-number"
        label="Politijournalnummer"
        @input="update('PoliceReportNumber', $event.target.value)"
        :validate-on-input="true"
      />
      <ValidationError name="police-report-number" />
    </div>

    <div class="control">
      <label for="police-district" class="text-question">
        <slot name="tooltip3" />
      </label>
      <Field
        id="police-district"
        :rules="{ required: required }"
        :value="modelValue.PoliceDistrict"
        :label="contentModel.ErrorMessagePoliceReportDistrict"
        name="police-district"
        type="text"
        @input="update('PoliceDistrict', $event.target.value)"
        :validate-on-input="true"
      />
      <ValidationError name="police-district" />
      <div>
        <div class="info-box is-shown push-down">
          {{ contentModel.PoliceReportInfoBoxText }}
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import DatePicker from '@/components/UI/Pickadate.vue';
import moment from 'moment';
import { Field } from 'vee-validate';
import ValidationError from '@/components/UI/ValidationError.vue';

export default {
  name: 'PoliceInformation',
  components: {
    DatePicker,
    Field,
    ValidationError
  },
  // inject: ['$validator'],
  props: {
    claimEventDate: {
      type: Object,
      default() {
        return {};
      }
    },
    contentModel: {
      type: Object,
      default() {
        return null;
      }
    },
    required: {
      type: Boolean,
      default() {
        return false;
      }
    },
    modelValue: {
      type: Object,
      default() {
        return null;
      }
    }
  },
  data() {
    return {
      maxDate: moment().local(),
      policeReportFiledDate: null
    };
  },
  created() {
    this.policeReportFiledDate = this.setPoliceReportFiledDate(
      this.modelValue.PoliceReportFiledDate
    );
  },
  unmounted() {
    if (!this.required) {
      this.$emit('update:modelValue', {
        PoliceDistrict: null,
        PoliceReportFiledDate: null,
        PoliceReportNumber: null
      });
    }
  },
  methods: {
    setPoliceReportFiledDate(date) {
      if (date !== null && !moment.isMoment(date)) {
        return moment(date).local();
      }

      return null;
    },
    update(key, value) {
      this.modelValue[key] = value;
      this.$emit('update:modelValue', this.modelValue);
    },
    updateDate(param) {
      this.policeReportFiledDate = moment(param).local();
      const paramDate = moment(param).local();
      this.update('PoliceReportFiledDate', paramDate.format());
    }
  }
};
</script>
